import { GoogleGenerativeAI } from '@google/generative-ai';

// Initialize Gemini AI with your API key
const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI_API_KEY);

// Initialize the model
const model = genAI.getGenerativeModel({ model: "gemini-pro" });

// System context for the AI
const SYSTEM_CONTEXT = `You are BookifyAI, a helpful and friendly bookstore assistant. 
You help users find books, make recommendations, and handle orders.
Be friendly, concise, and helpful in your responses.
Always maintain a conversational tone.`;

// Function to generate chat response
export async function generateChatResponse(userInput, bookCatalog) {
  try {
    // Prepare the prompt
    const prompt = `${SYSTEM_CONTEXT}\n\nAvailable books:\n${JSON.stringify(bookCatalog, null, 2)}\n\nUser: ${userInput}\nAssistant:`;

    // Generate content
    const result = await model.generateContent([{ text: prompt }]);
    const response = await result.response;
    
    const text = response.text();
    if (!text) {
      throw new Error('Empty response from Gemini AI');
    }

    return {
      success: true,
      message: text
    };

  } catch (error) {
    console.error('Gemini AI Error:', {
      message: error.message,
      name: error.name,
      stack: error.stack
    });

    return {
      success: false,
      message: "I apologize, but I'm having trouble processing your request at the moment. Please try again.",
      error: error.message
    };
  }
}
